<template>
  <div
    class="DetailCta">
    <BaseButton
      block
      theme="orange"
      :href="computedPrimaryCta.href(app)"
      @click="trackCta(computedPrimaryCta.text(app))">
      {{ computedPrimaryCta.text(app) }}
    </BaseButton>

    <!-- @NOTE TEMPORARILY REMOVED SECONDARY CTA -->
    <!-- <BaseButton
      v-if="app.priceType === 'negotiable'"
      class="mt-onehalf"
      block
      :href="computedSecondaryCta.href(app)">
      {{ computedSecondaryCta.text(app) }}
    </BaseButton> -->
  </div>
</template>

<script>
import BaseButton from '@/components/BaseButton.vue';

export default {
  name: 'DetailCta',

  components: {
    BaseButton,
  },

  data() {
    return {
      detailCtaMap: {
        primaryPaidCustomer: {
          text: () => 'REQUEST A QUOTE',
          href: (app) => this.getURL(
            'https://www.domo.com/login',
            app,
            (this.isWriteback ? 'connect' : 'quote'),
          ),
        },
        primaryPaidNonCustomer: {
          text: () => 'REQUEST A QUOTE',
          href: (app) => this.getURL(
            'https://www.domo.com/form/appstore',
            app,
            (this.isWriteback ? 'connect' : 'quote'),
          ),
        },

        primaryFreeCustomer: {
          text: (app) => `SIGN IN TO CONNECT ${app.type === 'app' ? 'APP' : ''}`,
          href: (app) => this.getURL(
            'https://www.domo.com/login',
            app,
            (app.type === 'app' ? 'app' : 'connect'),
          ),
        },
        primaryFreeNonCustomer: {
          text: (app) => `TRY FREE AND CONNECT ${app.type === 'app' ? 'APP' : ''}`,
          href: (app) => this.getURL(
            'https://www.domo.com/start/appstore',
            app,
            (app.type === 'app' ? 'app' : 'connect'),
          ),
        },

        secondaryPaidCustomer: {
          text: () => 'SEE IT IN ACTION',
          href: (app) => this.getURL('https://www.domo.com/login', app, 'trial'),
        },
        secondaryPaidNonCustomer: {
          text: () => 'SEE IT IN ACTION',
          href: (app) => this.getURL('https://www.domo.com/start/appstore', app, 'trial'),
        },
      },
    };
  },

  props: {
    app: { type: Object, required: true },
    userIsCustomer: { type: Boolean, default: false },
  },

  computed: {
    isWriteback() {
      return this.app.capability && this.app.capability.includes('Writeback');
    },

    computedPrimaryCta() {
      if (this.app.priceType === 'negotiable' || this.isWriteback) {
        return this.userIsCustomer
          ? this.detailCtaMap.primaryPaidCustomer
          : this.detailCtaMap.primaryPaidNonCustomer;
      }

      return this.userIsCustomer
        ? this.detailCtaMap.primaryFreeCustomer
        : this.detailCtaMap.primaryFreeNonCustomer;
    },

    computedSecondaryCta() {
      return this.userIsCustomer
        ? this.detailCtaMap.secondaryPaidCustomer
        : this.detailCtaMap.secondaryPaidNonCustomer;
    },
  },

  methods: {
    queryParams({ title, publisher, appstoreID }, campaignType = 'connect') {
      return `?utmrefresh=1&utm_source=${title}&utm_medium=domo&utm_campaign=Appstore_${publisher}_${appstoreID}_${campaignType}&utm_campid=701f2000001C6UOAA0`;
    },

    getURL(path, app, campaignType) {
      return encodeURI(`${path}${this.queryParams(app, campaignType)}`);
    },

    trackCta(text) {
      if (text.match('^TRY FREE AND CONNECT')) {
        this.$analytics.trackLink({ name: 'try-free-and-connect', position: 'cta' });
      }
    },
  },
};
</script>
